import { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom"; // Add useLocation

import "./index.css";
import "./App.css";

import Header from "./components/Header";
import Hero from "./components/Hero";
import TrendingCampaigns from "./components/TrendingCampaigns";
import Campaigns from "./components/Campaigns";
import LiveDonations from "./components/LiveDonations";
import Features from "./components/Features";
import Categories from "./components/Category";
import GlobalSection from "./components/GlobalSection";
import WhyChooseUs from "./components/WhyChooseUs";
import AboutSection from "./components/AboutSection";
import Testimonials from "./components/Testimonials";
import Footer from "./components/Footer";
import ContactUs from "./pages/ContactUs";

import AboutPage from "./components/AboutPage";
import CampaignDetailspage from "./pages/CampaignDetail";
import WorkFlow from "./components/WorkFlow";
import FundraiserForm from "./sign_in_files/FundraiserForm";
import VerifyMobileNumber from "./sign_in_files/verifyMobileNumber";
import DetailsScreen_1 from "./sign_in_files/detailsScreen1";
import DonationPage from "./components/DonationPage";
import MyContributions from './pages/MyContributions';
import MyFundraisers from './pages/MyFundraisers.js';
import AllCampaigns from './pages/AllCampaigns';
import CrowdfundingPage from './pages/CrowdfundingPage';
import Medical from './pages/Medical';
import StartFundraiser from './pages/StartFundraiser';


import PrivacyPolicy from './pages/PrivacyPolicy'; // Import Privacy Policy
import TermsAndConditions from './pages/TermsAndConditions';

import LoginPage from "./pages/LoginPage";

// ✅ ADD THIS IMPORT
import ScrollToTop from "./components/ScrollToTop";

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation(); // Get current location

  useEffect(() => {
    document.title = "Donatepe - The Leader in Online Fundraising";

    let metaDescription = document.querySelector("meta[name='description']");
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.name = "description";
      document.head.appendChild(metaDescription);
    }
    metaDescription.content =
      "Donatepe exists to share hope with the world by providing a free platform to raise money for causes you care about.";

    const timer = setTimeout(() => setIsLoading(false), 800);
    return () => clearTimeout(timer);
  }, []);

  // Check if current path is a campaign details page
  const isCampaignPage = location.pathname.includes('/campaign/');

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-gray-100 to-white">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-teal-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-teal-600 font-semibold">Loading Donatepe...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="App min-h-screen flex flex-col bg-white">
      {/* ✅ ADD THIS HERE */}
      <ScrollToTop />

      {/* GLOBAL HEADER - Conditionally hidden on campaign pages for mobile */}
      <div className={isCampaignPage ? 'hidden lg:block' : 'block'}>
        <Header />
      </div>

      {/* ROUTES */}
      <main className="flex-grow">
        <Routes>
          {/* HOME PAGE */}
          <Route
            path="/"
            element={
              <>
                <Hero />
                <WorkFlow />
                 <Campaigns />
               
                <Features />
                <WhyChooseUs />
                <AboutSection />
                <Testimonials />
                <Categories />
               
              </>
            }
          />

          {/* ABOUT PAGE */}
          <Route path="/about" element={<AboutPage />} />

          {/* SIGN IN PAGE */}
          <Route path="/signin" element={<LoginPage />} />

          {/* CAMPAIGN DETAILS PAGE */}
          <Route path="/campaign/:slugWithId" element={<CampaignDetailspage />} />

          {/* EXISTING ROUTES */}
          <Route path="/start-fundraiser" element={<FundraiserForm />} />
          <Route path="/verify_mobileNumber" element={<VerifyMobileNumber />} />
          <Route path="/detailsScreen" element={<DetailsScreen_1 />} />
          {/* CONTACT US PAGE */}
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/campaigns" element={<AllCampaigns />} />
          
          <Route path="/my-contributions" element={<MyContributions />} />
          <Route path="/my-fundraiser" element={<MyFundraisers />} />

          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />


           <Route path="/crowdfundraisers" element={<CrowdfundingPage />} />
            <Route path="/medical" element={<Medical />} />
             <Route path="/start-fundraiser-page" element={<StartFundraiser />} />

          {/* Optional: Route for all campaigns listing */}
          <Route
            path="/campaigns"
            element={
              <>
                <Hero />
                <Campaigns />
              </>
            }
          />

          {/* Optional: Fallback route for 404 */}
          <Route
            path="*"
            element={
              <div className="min-h-screen flex items-center justify-center">
                <div className="text-center">
                  <h1 className="text-3xl font-bold text-gray-900 mb-4">
                    404 - Page Not Found
                  </h1>
                  <p className="text-gray-600">
                    The page you're looking for doesn't exist.
                  </p>
                </div>
              </div>
            }
          />
        </Routes>
      </main>

      {/* GLOBAL FOOTER */}
      <Footer />
    </div>
  );
}

export default App;